import React, {useState, useEffect, Fragment} from 'react'
import flatstore from 'flatstore';
import Loader from '../../../components/ui/Loader';
import LoadModules from '../../../components/ui/LoadModules'
import {getStatic} from '../../../utils/services';
//import parse from 'html-react-parser';
import Image from '../../../components/ui/Image'
import Meta from '../../../components/ui/Meta';
import {isNil} from 'lodash';

import cow from '../../../assets/img/mission/cow.png';
import chicken from '../../../assets/img/mission/chicken.png';



const Mission = ({loading, static_data}) => {
    const [data, setData] = useState(null);
    const [modules, setModules] = useState(0);
    useEffect(() => {
        static_data = null;
    }, [])

    useEffect(() => {

		if (isNil(static_data)) {
            getStatic('mission', 'static_data');
        }
        if(!data){
            setData(static_data);
        }
        
		if(static_data && static_data.modules !== null){
            setModules(static_data.modules);
		}
		
    }, [static_data]);
    
    if (loading) {
		return <Loader />
	} else {

        return (
            <Fragment>
                <LoadModules modules={modules} type="top" />
                {data &&
                    <Meta
                        title={data.seo_title ? data.seo_title : data.title}
                        description={data.seo_description}
                    />
                }

                <LoadModules modules={modules} type="bottom" />

            </Fragment>
        )
    }
}

export default flatstore.connect(['loading', 'static_data'])(Mission);
